<template>
  <div class="status-icon">
    <span
      v-if="showCircle"
      class="status-icon__circle"
      :class="`status-icon__circle--${status}`"
    ></span>
    <LoadingSmallSpinner v-else />
  </div>
</template>
<script>
import LoadingSmallSpinner from '@/components/loaders/LoadingSmallSpinner.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'LabStatusIcon',
  components: { LoadingSmallSpinner },
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    showCircle() {
      const canShow = [
        CONSTANTS.LABS.SESSION_STATUS.IDDLE,
        CONSTANTS.LABS.SESSION_STATUS.STARTED,
        CONSTANTS.LABS.SESSION_STATUS.STOPPED,
        CONSTANTS.LABS.SESSION_STATUS.TERMINATED,
      ]
      return canShow.includes(this.status)
    },
  },
}
</script>
<style lang="scss" scoped>
.status-icon {
  &__circle {
    width: 12.94px;
    height: 13px;
    background: var(--tundora-gray);
    transition: 0.5s background-color ease;
    display: block;
    border-radius: 50%;
    &--started {
      background: #00da99;
    }
    &--stopped,
    &--terminated {
      background: #e52a2a;
    }
  }
}
</style>
